import { IUsuario } from 'types/usuario'

export const itsCompleteRegistration = (user: IUsuario) => {
  let isComplete = true
  if (!user.cpf) isComplete = false
  if (!user.ddd || !user.telefone) isComplete = false
  return isComplete
}
